import type { OpenOrdersFilter } from '../api/types'

const STORAGE_KEY = 'spi-ops:open-orders:saved-searches'

export interface SavedSearch {
  id: string
  label: string
  filter: OpenOrdersFilter
  createdAt: string
}

export function loadSaved(): SavedSearch[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw) as unknown
    if (!Array.isArray(parsed)) return []
    return parsed as SavedSearch[]
  } catch {
    return []
  }
}

export function persistSaved(list: SavedSearch[]): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list))
  } catch {
    // quota / private mode — non-fatal
  }
}

export function addSaved(label: string, filter: OpenOrdersFilter): SavedSearch[] {
  const list = loadSaved()
  const item: SavedSearch = {
    id: `s-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    label,
    filter,
    createdAt: new Date().toISOString(),
  }
  const next = [item, ...list].slice(0, 20) // cap
  persistSaved(next)
  return next
}

export function removeSaved(id: string): SavedSearch[] {
  const next = loadSaved().filter((s) => s.id !== id)
  persistSaved(next)
  return next
}
